export default "__VITE_ASSET__yfiH9RrW__"